<template>
  <div>
    <Card>
      <h2>详情</h2>
    </Card>
    <Card>
      <p class="approvalCodeStyle">审批编号：{{ detailData.applyNo }}</p>
      <h2>{{ detailData.title }}</h2>
      <v-form-render
        ref="vformrender"
        :form-json="renderJson"
        :form-data="formData"
        :option-data="optionData"
        :fileUploadObj="fileUploadObj"
        class="marginStyle"
        @fileDownClick="fileDownClick"
        @filePreviewClick="filePreviewClick"
      />
      <div class="marginStyle">
        <Form ref="dataForm" :model="dataForm" :rules="dataFormValid" v-bind:label-width="90">
          <FormItem label="所在部门：" prop="applyDepartmentId">
            <Select v-model="dataForm.applyDepartmentId" placeholder="请选择" @on-change="applyDepartmentChange">
              <Option v-for="item in applyDepartmentList" :value="item.departmentRelId" :key="item.departmentRelId">{{ item.fullDepartmentName }}</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
    </Card>
    <Card>
      <p slot="title">添加抄送人</p>
      <CopyerSetting ref="CopyerSetting" :dataConfig.sync="dataConfig" typeTitle="抄送人" :multiple="true" />
    </Card>
    <div style="background: #ddd">
      <Button v-if="hasFullscreen" type="warning" @click="handleReturnList">返回审批列表</Button>
      <Button
        v-for="(btn, index) in footerButtonArr"
        :key="index"
        :type="btn.type"
        @click="btn.fun(btn.params)"
        :icon="btn.icon"
        style="margin:10px;"
        >
          {{ btn.message }}
        </Button>
    </div>
  </div>
</template>

<script>
import CopyerSetting from '../../approvalTask/approvalDetail/template/copyerSetting/coperSetting.vue'; // 抄送人
import { getDepartMentApi, saveApprovalDraftApi, submitApprovalApi, getFormJsonDataApi } from '@/api/lauchApproval';
import { instApplyDetailApi, actionOpApi, checkFormValuUnique } from '@/api/approvalTask';
import { config } from './config';
import util from '@/assets/js/util';
export default {
  components: {
    CopyerSetting
  },
  computed: {
    hasFullscreen() {
      const { fullscreen = false } = this.$route.query;
      return fullscreen;
    }
  },
  data() {
    return {
      config,
      dataConfig: { // 抄送人配置
        userType: 0 // 抄送人类型：0不添加抄送人, 1：指定人员，2：指定部门，3：指定角色，4：指定部门主管，5：指定直属主管
      },
      detailData: {}, // 详情数据
      dataForm: { // 表单
        applyDepartmentId: '' // 申请部门id
      },
      editStorageData: {}, // 修改审批的部门暂存数据
      dataFormValid: { applyDepartmentId: { required: true, message: '请填写所在部门', trigger: 'blur' } },
      renderJson: {}, // 动态表单回显JSON
      formData: {}, // 动态表单数据
      optionData: {},
      tplConfigId: '', // 模板id
      instApplyId: '', // 草稿id
      applyDepartmentList: [], // 所在部门列表
      applyDepartmentName: '', // 所在部门名称
      footerButtonArr: [ // 底部按钮
        { message: '提交', type: 'primary', fun: this.submitInfo, params: 'submit' },
        { message: '保存草稿', type: 'info', fun: this.submitInfo, params: 'saveDraft' }
      ],
      fileUploadObj: {
        uploadId: { key: 'bucketAppRelId', value: '' }, // 文件上传id
        hosts: `https://${process.env.VUE_APP_DFS_HOST}`, // 文件上传请求域名
        headers: { 'X-Token-91': `${JSON.parse(localStorage.userInfo).token}` }
      }
    };
  },
  methods: {
    async submitInfo(type) {
      // type： submit提交，saveDraft保存草稿
      const vformRender = this.$refs.vformrender;
      const formOrigData = await vformRender.getFormData(); // 获取动态表单数据
      // 所在部门校验
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          const { userType } = this.$refs.CopyerSetting.dataConfig; // 获取抄送人类型
          const notifyUserIds = []; // 抄送人数据
          let notifyUserUiInfo;
          const summary = this.getSummary(formOrigData);
          // 如果是指定人员 || 指定部门 || 指定角色(因为这三个用的同一个数组里不同的key值，所以需要取里面一层的数据)
          if ([1, 2, 3].includes(userType)) {
            notifyUserUiInfo = JSON.stringify(this.$refs.CopyerSetting[config.CopyerObjMap[userType]][config.CopyerChildObjMap[userType]]);
            this.$refs.CopyerSetting[config.CopyerObjMap[userType]][config.CopyerChildObjMap[userType]].forEach(item => {
              const idName = userType == 2 ? 'relationId' : 'id';
              notifyUserIds.push(item[idName]);
            });
          } else {
            notifyUserUiInfo = JSON.stringify(this.$refs.CopyerSetting[config.CopyerObjMap[userType]]);
            notifyUserIds.push(this.$refs.CopyerSetting[config.CopyerObjMap[userType]]);
          }
          const data = Object.assign(
            { formOrigData }, // 表单数据
            { notifyUserIds }, // 抄送人数据
            {
              summary,
              ...this.dataForm, // 标表单数据（所在部门）
              notifyUserType: userType, // 抄送类型
              tplConfigId: this.tplConfigId, // 审批模板的唯一标识
              instApplyId: this.instApplyId, // 草稿id（如果不是草稿进入，此id位空）
              applyDepartmentName: this.applyDepartmentName, // 所在部门的名称
              notifyUserUiInfo
            }
          );
          const res = type != 'saveDraft' ? await this.repeatValid(formOrigData) : true;
          if (res) {
            this[type](data);
          } else {
            this.$Message.error('表单内容重复，请检查');
          }
        }
      });
    },
    // 重复校验
    repeatValid(data) {
      return new Promise((resolve, reject) => {
        const keyValList = [];
        const { widgetList } = this.renderJson;
        if (widgetList && widgetList instanceof Array && widgetList.length > 0) {
          widgetList.forEach(item => {
            if ((item.type != 'table' || item.type != 'grid') && item.options.noAllowRepeat == true) {
              const id = item.options.name;
              keyValList.push({ id, name: data[item.options.name] });
            }
          });
        }
        const params = { tplConfigId: this.tplConfigId, instApplyId: '', keyValList };
        checkFormValuUnique(params).then(res => {
          const { code, data } = res.data;
          if (code == 200 && data != true) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 提交
    submit(data) {
      this.$Modal.confirm({
        title: '确认要提交审批吗',
        content: '确认后将提交该审批',
        onOk: () => {
          if (this.mode == 'edit') {
            // 如果是修改的数据要提交
            data.taskData = data.formOrigData;
            const dataObj = Object.assign({ ...data, ...this.editStorageData });
            actionOpApi(dataObj).then(res => {
              const { code, msg, data } = res.data;
              if (code == 200) {
                let path = '/successTransfer';
                const query = { instApplyId: data };
                if (this.hasFullscreen) {
                  path = '/approvalTaskMaximize';
                  query.fullscreen = true;
                }
                this.$Message.success(msg || '操作成功');
                this.$router.push({ path, query });
              }
            });
          } else {
            submitApprovalApi(data).then(res => {
              const { code, msg, data } = res.data;
              if (code == 200) {
                let path = '/successTransfer';
                const query = { instApplyId: data };
                if (this.hasFullscreen) {
                  path = '/approvalTaskMaximize';
                  query.fullscreen = true;
                }
                this.$Message.success(msg || '操作成功');
                this.$router.push({ path, query });
              }
            });
          }
        }
      });
    },
    // 保存草稿
    saveDraft(data) {
      saveApprovalDraftApi(data).then(res => {
        const { code, msg } = res.data;
        if (code == 200) {
          this.$Message.success(msg || '操作成功');
          this.$router.push('/launchApproval');
        }
      });
    },
    // 获取摘要
    getSummary(formOrigData) {
      try {
        let str = '';
        const renderJsonArr = [];
        const renderJson = util.hardCopyJson(this.renderJson.widgetList);
        if (renderJson && renderJson instanceof Array && renderJson.length > 0) {
          renderJson.forEach(item => {
          // 如果不是表格和栅格类型的
            if (!['table', 'grid'].includes(item.type)) {
              const { label, name } = item.options;
              renderJsonArr.push({ label, name, type: item.type });
            }
          });
        }
        // 如果表单为3个以上，就取前3个做摘要
        for (let i = 0; i < (renderJsonArr.length >= 3 ? 3 : renderJsonArr.length); i++) {
          const { label, name, type } = renderJsonArr[i];
          str += `${label}:${formOrigData[name] ? formOrigData[name] : '--'};`;
          // if (type == 'date') {
          // // 如果是时间类型，转换一下格式
          //   str += `${label}:${formOrigData[name] ? util.formatDateTime('yyyy-MM-dd hh:mm:ss', formOrigData[name]) : '--'};`;
          // } else {
          //   str += `${label}:${formOrigData[name] ? formOrigData[name] : '--'};`;
          // }
        }
        return str;
      } catch (err) {
        alert('获取摘要失败');
      }
    },
    // 获取表单权限
    setDisableForm(formOpAuthList, data) {
      try {
        if (formOpAuthList && formOpAuthList instanceof Array && formOpAuthList.length > 0) {
          // 循环权限数组
          formOpAuthList.forEach(item => {
            data.widgetList.forEach(ele => {
            // 循环渲染的json
              if (ele.type == 'table') {
              // 如果是表格 ，单独处理里面的权限
                ele.rows[0].cols.forEach((tableItem, tableIndex) => {
                  if (tableItem.widgetList[0].options.name == item.formItemKey) {
                    if (item.formOpAuthType == 1) {
                      ele.rows.forEach(tableRowItem => {
                      // 将里面对应的列设置
                        tableRowItem.cols[tableIndex].widgetList[0].options.disabled = false;
                        tableRowItem.cols[tableIndex].widgetList[0].options.hidden = false;
                      });
                    } else if (item.formOpAuthType == 2) { // 1：可编辑，2：禁用：3：隐藏
                      ele.rows.forEach(tableRowItem => {
                      // 将里面对应的列设置
                        tableRowItem.cols[tableIndex].widgetList[0].options.disabled = true;
                        tableRowItem.cols[tableIndex].widgetList[0].options.hidden = false;
                      });
                    } else if (item.formOpAuthType == 3) { // 1：可编辑，2：禁用：3：隐藏
                      ele.rows.forEach(tableRowItem => {
                      // 将里面对应的列设置
                        tableRowItem.cols[tableIndex].widgetList[0].options.hidden = true;
                      });
                    }
                  }
                });
              } else {
                if (ele.options.name == item.formItemKey) {
                  if (item.formOpAuthType == 1) {
                    ele.options.disabled = false;
                    ele.options.hidden = false;
                  } else if (item.formOpAuthType == 2) { // 1：可编辑，2：禁用：3：隐藏
                    ele.options.disabled = true;
                    ele.options.hidden = false;
                  } else if (item.formOpAuthType == 3) { // 1：可编辑，2：禁用：3：隐藏
                    ele.options.hidden = true;
                  }
                }
              }
            });
          });
        }
      } catch (err) {
        alert('表单权限配置失败');
      }
    },
    // 获取部门
    getDepartment(tplConfigId) {
      getDepartMentApi(tplConfigId).then(res => {
        const { data } = res.data;
        this.applyDepartmentList = data;
        if (!this.mode) {
          // 如果mode为空的话，证明是新增，然后展示默认的
          if (Array.isArray(data) && data.length > 0) {
            const defaultDpt = data.find(i => i.masterRoleDepartment);
            if (defaultDpt) {
              this.dataForm.applyDepartmentId = defaultDpt.departmentRelId;
              this.applyDepartmentName = defaultDpt.fullDepartmentName;
            } else {
              this.dataForm.applyDepartmentId = data[0].departmentRelId;
              this.applyDepartmentName = data[0].fullDepartmentName;
            }
          }
        }
      });
    },
    // 所在部门change
    applyDepartmentChange(e) {
      this.applyDepartmentName = this.applyDepartmentList.find(item => item.departmentRelId == e).fullDepartmentName;
    },
    // 返回数据处理
    formatData(data) {
      const { tplConfigId = '', applyDepartmentId = '', applyDepartmentName = '', notifyUserType, notifyUserUiInfo = '[]', notifyUserIds, formOpAuthList = [], bucketAppRelId } = data;
      this.fileUploadObj.uploadId.value = bucketAppRelId; // 文件上传用到的id
      const notifyUserUiInfoData = JSON.parse(notifyUserUiInfo || '[]');
      this.dataConfig = {
        ...this.dataConfig,
        nodeUserList: notifyUserUiInfoData,
        nodeExecUsers: notifyUserIds,
        userType: notifyUserType
      };
      const CopyerSettingDom = this.$refs.CopyerSetting;
      CopyerSettingDom.initData(this.dataConfig);
      this.tplConfigId = tplConfigId;
      this.setFormDataInfo(data);
      this.dataForm.applyDepartmentId = applyDepartmentId; // 所在部门id
      this.applyDepartmentName = applyDepartmentName; // 所在部门名称
    },
    // 渲染表单数据
    async setFormDataInfo(data) {
      if (this.mode == 'draft') {
        const { formOpAuthList, formDesignDef, applyNo, title } = data;
        this.detailData = { applyNo, title };
        this.setDisableForm(formOpAuthList, formDesignDef);
        this.$refs.vformrender.setFormJson(formDesignDef);
      } else {
        await this.getFormJsonData(this.tplConfigId);
      }
      this.$nextTick(() => {
        this.$refs.vformrender.setFormData(data.formCurrData);
      });
    },
    async getFormJsonData(tplConfigId) {
      await getFormJsonDataApi(tplConfigId).then(res => {
        const { data, code } = res.data;
        if (code == 200) {
          const { formDef, formOpAuthList, applyNo, title, bucketAppRelId } = data;
          this.detailData = { applyNo, title };
          this.fileUploadObj.uploadId.value = bucketAppRelId; // 文件上传用到的id
          this.$refs.vformrender.setFormJson(formDef);
          this.setDisableForm(formOpAuthList, formDef); // 设置表单权限
        }
      });
    },
    fileDownClick(file) {
      util.fileDownloadBydomanType({ ajax: this.$ajax, url: `/v1/dfs/down/${file.response.data}`, domainType: 'dfsApi', method: 'get', fileName: file.name });
    },
    filePreviewClick(file) {
      this.$ajax.get(`/v1/dfs/preview/${file.response.data}`, { domainType: 'dfsApi' }).then(res => {
        const { data } = res.data;
        window.open(data);
      });
    },
    // 返回审批列表
    handleReturnList() {
      this.$router.push({
        path: '/approvalTaskMaximize',
        query: { fullscreen: true }
      });
    }
  },
  async mounted() {
    const { id = '', mode = '' } = this.$route.query;
    this.mode = mode;
    if (['draft', 'edit'].includes(mode)) {
      // 如果草稿，通过草稿的id掉详情接口获取tplConfigId
      this.instApplyId = id;
      if (mode == 'edit') {
        this.editStorageData = { actionType: 102, instApplyId: id };
        this.footerButtonArr = [
          { message: '提交', type: 'primary', fun: this.submitInfo, params: 'submit' }
        ];
      }
      await instApplyDetailApi(id).then(res => {
        const { data } = res.data;
        this.formatData(data);
      });
    } else {
      // 模板列表进来的
      this.tplConfigId = id;
      this.getFormJsonData(this.tplConfigId); // 获取模板数据
    }
    this.getDepartment(this.tplConfigId); // 获取部门
  }
};
</script>

<style scoped>
.approvalCodeStyle {
  color: #aaa;
  margin-bottom: 5px;
  font-size: 14px;
}
.marginStyle {
  margin-top: 18px;
}
</style>
